import React, { useEffect } from "react";

import { usePostOptions } from "store/popover/usePostOptionStore";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from "components/ui/dropdown-menu";

interface PostOptionProps {
  isOpen: boolean;
  post: any;
  onOpenChange: (open: boolean) => void;
  buttonRef: HTMLButtonElement | null;
  handleOptionClick: (post: any, optionKey: string) => void;
}

const PostOption: React.FC<PostOptionProps> = ({ isOpen, post, onOpenChange, buttonRef, handleOptionClick }) => {
  // * === Store === //

  const { options, initializePage } = usePostOptions();

  // * === Variable === //

  // * === Functions === //
  // const handleOptionClick = (post: any, label: any) => {
  //   if (label === "Share Post") {
  //     onClickShare({
  //       label: label,
  //       post: post,
  //     });
  //   } else if (label === "Block User") {
  //     onClickShare({
  //       label: label,
  //       post: post,
  //     });
  //   } else if (label === "Boring User") {
  //     onClickShare({
  //       label: label,
  //       post: post,
  //     });
  //   } else if (label === "Delete Post") {
  //     onClickShare({
  //       label: label,
  //       post: post,
  //     });
  //   } else if (label === "Report Post") {
  //     onClickShare({
  //       label: label,
  //       post: post,
  //     });
  //   } else if (label === "Boost Post") {
  //     onClickShare({
  //       label: label,
  //       post: post,
  //     });
  //   } else {
  //     console.log(`Clicked on ${label}`);
  //   }
  // };

  // * === useEffect === //
  useEffect(() => {
    if (post) initializePage(post);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [post]);

  return (
    <>
      <DropdownMenu open={isOpen} onOpenChange={onOpenChange}>
        <DropdownMenuContent
          side="bottom"
          align="start"
          sideOffset={12}
          style={{
            position: "absolute",
            top: window.innerWidth <= 884 ? 270 : (buttonRef?.getBoundingClientRect().bottom ?? 50) + 12,

            // left: buttonRef?.getBoundingClientRect().left ?? 1530,
            // left: buttonRef?.getBoundingClientRect().left ?? (window.innerWidth > 1500 ? 1530 : 890),
            // left: buttonRef?.getBoundingClientRect().left ?? (window.innerWidth > 1500 ? 1530 : 890 ),
            left: window.innerWidth <= 884 ? 490 : buttonRef?.getBoundingClientRect().left ?? (window.innerWidth > 1500 ? 1530 : 890),
          }}
          className="w-96 rounded-xl p-2 shadow-xl bg-popover z-50"
        >
          {Object.values(options)
            .filter((opt) => opt.available)
            .map((opt, index, arr) => (
              <React.Fragment key={opt.key}>
                <DropdownMenuItem className="gap-3 items-start px-3 py-2 rounded-md hover:bg-accent cursor-pointer" onClick={() => handleOptionClick(post, opt.key)}>
                  <img src={opt.image} alt={opt.label} className={`w-7 h-7 mt-1 shrink-0 ${opt.themeable ? "dark:brightness-0 dark:invert" : ""}`} />
                  <div className="flex flex-col">
                    <span className="font-medium leading-none">{opt.label}</span>
                    <span className="text-sm text-muted-foreground">{opt.sub_title}</span>
                  </div>
                </DropdownMenuItem>

                {/* 🔥 Only show separator if not the last item */}
                {index < arr.length - 1 && <DropdownMenuSeparator />}
              </React.Fragment>
            ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export default PostOption;

